import * as React from 'react';
import classnames from 'classnames';

const FlexLayout = ({ alignContent ='stretch' , alignItems ='stretch' , direction ='row' , justify ='flex-start' , wrap ='nowrap' , children , component: Component = 'div' ,  })=>{
    const classNames = classnames('flex-layout', `flex-layout--align-content-${alignContent}`, `flex-layout--align-items-${alignItems}`, `flex-layout--direction-${direction}`, `flex-layout--justify-${justify}`, `flex-layout--wrap-${wrap}`);
    return /*#__PURE__*/ React.createElement(Component, {
        className: classNames
    }, children);
};
var FlexLayout$1 = FlexLayout;

export { FlexLayout$1 as default };
//# sourceMappingURL=FlexLayout.js.map
